<app-menu-crud></app-menu-crud>
<div class="content-layer content-layer-route" [ngClass]="{'drag-menu-active': (svcMenuBase.svcMenuDrag.menuOpen | async), 'crud-menu-active':(svcMenuBase.svcMenuCrud.menuOpen | async)}">
	<router-outlet class="outlet"></router-outlet>
</div>
<app-menu-drag></app-menu-drag>
<app-ui-video-bg></app-ui-video-bg>